import * as mutationsType from './mutationsType'
export default {
  //保存用户信息
  saveWebUserInfo ({ commit }, webUserInfo) {
    commit(mutationsType.RECEIVE_WEB_USER_INFO, { webUserInfo })
  },

  //保存admin用户信息
  saveAdminUserInfo ({ commit }, adminUserInfo) {
    commit(mutationsType.RECEIVE_ADMIN_USER_INFO, { adminUserInfo })
  },

  //清除前台用户信息
  clearWebUserInfo ({ commit }) {
    commit(mutationsType.CLEAR_WEB_USER_INFO)
  },

  //清除admin用户信息
  clearAdminUserInfo ({ commit }) {
    commit(mutationsType.CLEAR_ADMIN_USER_INFO)
  },

  //更新前台用户token信息
  updateWebToken ({ commit }, token) {
    commit(mutationsType.UPDATE_WEB_TOKEN, { token })
  },

  //更新后台用户token信息
  updateAdminToken ({ commit }, token) {
    commit(mutationsType.UPDATE_WEB_TOKEN, { token })
  },

}
